export const GENERIC_ERROR_TEXT = 'Oops! Something wrong here';

export const API_STATUS = {
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS',
  LOADING: 'LOADING'
};
